import React from 'react';
import { Segment } from 'semantic-ui-react';
import { TranslateFunction } from 'react-localize-redux';

import DataTable, { Column } from '@/components/DataTable';
import { MappableArticle } from '@/types';
import ArticleSearchSelect from './ArticleSearchSelect';

interface Props {
    translate: TranslateFunction;
    articles: MappableArticle[];
    selectionFor: (article: MappableArticle) => string | undefined;
    onChange: (article: MappableArticle, externalReference: string | null) => void;
    renderSaveButton: () => React.ReactElement;
}

const ArticleMappingsTable: React.FC<Props> = (props) => {
    const {
        translate,
        articles,
        selectionFor,
        onChange,
        renderSaveButton,
    } = props;

    const vatRenderer = (article: MappableArticle) =>
        typeof article.VAT === 'number' ? `${article.VAT * 100}%` : '';

    const priceRenderer = (article: MappableArticle) => `${article.Price ?? ''}${article.PriceSign ?? ''}`;

    const mappingRenderer = (article: MappableArticle, rowIndex: number) => (
        <ArticleSearchSelect
            upward={rowIndex === articles.length - 1}
            value={selectionFor(article)}
            vatPercent={parseFloat(String(article.VAT))}
            data-cy={`select-mapping-eaccounting-article-${rowIndex}`}
            onChange={(externalReference) => onChange(article, externalReference)}
        />
    );

    const columns: Column[] = [
        { name: translate('articles.Id'), attribute: 'Id' },
        { name: translate('articles.name'), attribute: 'Name' },
        { name: translate('articles.price'), renderer: priceRenderer },
        { name: translate('prices.VAT'), renderer: vatRenderer },
        { name: translate('prices.eaccountingArticle'), renderer: mappingRenderer },
    ];

    return (
        <Segment>
            <DataTable
                style={{ minHeight: '400px' }}
                columns={columns}
                data={articles}
                virtualized
                nowrap
            />
            {renderSaveButton()}
        </Segment>
    );
};

export default ArticleMappingsTable;
